import React from "react";
import "./WebDevelopmentPackages.css";

const WebDevelopmentPackages = () => {
  return (
    <div className="web-package-page">

      <div className="package-banner">
        <h1>Web Development Services & Packages</h1>
        <p>
          Service Offerings, Technical Scope & Onboarding Checklist (INR Pricing)
        </p>
      </div>

      <div className="notice-box">
        <strong>Client Notice:</strong> All listed package prices exclude
        individual domain acquisition, third-party premium hosting subscriptions,
        and standard statutory transaction taxes. Fully fluid mobile-responsive
        layout engineering and multi-viewport testing come configured as standard
        infrastructure across all tiers.
      </div>

      {/* PACKAGE TABLE */}

      <section className="package-section">
        <h2>1. Master Package Comparison Matrix</h2>

        <div className="table-responsive">
          <table>
            <thead>
              <tr>
                <th>Feature / Service Attribute</th>
                <th>🟢 Basic Tier</th>
                <th>🔵 Standard Tier</th>
                <th>🟣 Premium Tier</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Primary Target Audience</td>
                <td>Local shops, standalone landing pages, simple portfolio sites.</td>
                <td>Growing small-to-medium businesses, professional service brands, content publishers.</td>
                <td>E-commerce brands, high-traffic corporate portals, customized workflow applications.</td>
              </tr>

              <tr>
                <td>Page Architecture Scope</td>
                <td>Single-Page Scroll Structure (Up to 5 logical viewport content blocks).</td>
                <td>Multi-Page Layout Structure (Up to 6–8 distinct pages).</td>
                <td>Extensive / Architecture-Unlimited Dynamic Pages.</td>
              </tr>

              <tr>
                <td>Design Customization UI/UX</td>
                <td>Modern Template Modification tailored to brand colors.</td>
                <td>Semi-Custom Tailored Layout Framework.</td>
                <td>100% Bespoke UI/UX Focused Wireframing & Prototyping.</td>
              </tr>

              <tr>
                <td>CMS & Administrative Backend</td>
                <td>Static Code / Manual Updates.</td>
                <td>Full CMS Integration (WordPress/Webflow/Wix).</td>
                <td>Advanced Custom Dashboard Environment.</td>
              </tr>

              <tr>
                <td>Search Engine Optimization</td>
                <td>Meta Tags & Sitemap Setup.</td>
                <td>Standard On-Page Optimization.</td>
                <td>Deep Market SEO & Structured Schema Markup.</td>
              </tr>

              <tr>
                <td>E-Commerce Architecture</td>
                <td>Not Available.</td>
                <td>Basic Setup (Up to 5 Products).</td>
                <td>Complete E-Commerce Engine.</td>
              </tr>

              <tr>
                <td>Payment Gateway Infrastructure</td>
                <td>Not Integrated</td>
                <td>Direct Contact Triggers Only.</td>
                <td>Razorpay, Paytm, Stripe Integration.</td>
              </tr>

              <tr>
                <td>Post-Launch Support</td>
                <td>3 Business Days</td>
                <td>15 Days Priority Support</td>
                <td>45 Days Priority Support SLA</td>
              </tr>

              <tr>
                <td>Baseline Investment Scale</td>
                <td>Starts at ₹5,000</td>
                <td>₹25,000 - ₹60,000</td>
                <td>₹85,000+</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* BASIC */}

      <section className="package-card basic">
        <h2>🟢 Basic Package — The One-Page Launchpad Checklist</h2>

        <p>
          Best suited for hyper-local micro-businesses, personal expert
          profiles, and straightforward target landing pages seeking rapid
          digital deployment.
        </p>

        <ul>
          <li>Single-Page Scrolling UI Architecture</li>
          <li>Direct Communication APIs</li>
          <li>External Channel Interfacing</li>
          <li>Google Maps & Search Console Grounding</li>
          <li>Foundational Page Optimization</li>
        </ul>
      </section>

      {/* STANDARD */}

      <section className="package-card standard">
        <h2>🔵 Standard Package — The Brand Builder Checklist</h2>

        <p>
          Tailored for verified business firms, consultancy teams and content
          creators seeking lead generation and growth.
        </p>

        <ul>
          <li>Extended Site Infrastructure (Up to 8 Pages)</li>
          <li>Self-Managed CMS Setup</li>
          <li>Automated Marketing Integrations</li>
          <li>Advanced Structural SEO</li>
          <li>Core Web Vitals Optimization</li>
        </ul>
      </section>

      {/* PREMIUM */}

      <section className="package-card premium">
        <h2>🟣 Premium Package — The High-Growth Storefront Checklist</h2>

        <p>
          Built for scale-ready brands, enterprise portals and complete
          e-commerce infrastructure.
        </p>

        <ul>
          <li>Full E-Commerce Core & Architecture</li>
          <li>Payment Gateway Integration</li>
          <li>Automated Business Logic Mapping</li>
          <li>Protected Customer Portals</li>
          <li>Enterprise Security Systems</li>
        </ul>
      </section>

      {/* OPTIONAL */}

      <section className="optional-services">
        <h2>3. Optional Modernizations & Component Pricing</h2>

        <div className="optional-grid">

          <div className="optional-card">
            <h3>Multi-Page Extension</h3>
            <p>Convert single-page architecture into multiple pages.</p>
            <span>+₹2,500 Per Page</span>
          </div>

          <div className="optional-card">
            <h3>Hosting & DNS Setup</h3>
            <p>Hosting setup, DNS configuration & domain linking.</p>
            <span>+₹1,500</span>
          </div>

          <div className="optional-card">
            <h3>Performance Optimization Sprint</h3>
            <p>Improve website speed to 90+ mobile score.</p>
            <span>+₹6,000</span>
          </div>

          <div className="optional-card">
            <h3>SEO Copywriting</h3>
            <p>SEO-friendly business content writing.</p>
            <span>+₹2,000 / Page</span>
          </div>

          <div className="optional-card">
            <h3>AMC Maintenance</h3>
            <p>Monthly maintenance & support.</p>
            <span>₹2,500 / Month</span>
          </div>

        </div>
      </section>

      {/* CLIENT CHECKLIST */}

      <section className="launch-section">

        <h2>4. Client Launch & Asset Readiness Checklist</h2>

        <div className="launch-grid">

          <div className="launch-card">
            <h3>Credential Provisioning</h3>
            <p>
              Domain credentials, hosting panel credentials and platform access.
            </p>
          </div>

          <div className="launch-card">
            <h3>Brand Asset Pack</h3>
            <p>
              Logos, typography files, color palette and design resources.
            </p>
          </div>

          <div className="launch-card">
            <h3>Copy & Content Assets</h3>
            <p>
              Website content, privacy policy, service descriptions and legal
              pages.
            </p>
          </div>

          <div className="launch-card">
            <h3>Analytics & Search Console</h3>
            <p>
              Google Analytics, Search Console and business profile setup.
            </p>
          </div>

          <div className="launch-card">
            <h3>Payment Gateway Credentials</h3>
            <p>
              Razorpay, Paytm, Stripe and merchant account verification.
            </p>
          </div>

        </div>

      </section>

    </div>
  );
};

export default WebDevelopmentPackages;